<template>
    <b-container class="bv-example-row">
        <b-row>
            <b-col>
                <b-alert show variant="light" class="alert alert-custom alert-white alert-shadow fade show gutter-b">
                    <div class="alert-icon">
                        <span class="svg-icon svg-icon-lg">
                            <inline-svg src="media/svg/icons/Tools/Compass.svg" />
                        </span>
                    </div>
                    <div class="alert-text">
                        You are seeing a sensor without internet connection, this device might look offline sometimes due to the sync coverange in the area
                        <SuitchFavourite :device="current_device"/>
                    </div>
                </b-alert>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <SuitchChartWidget :device="current_device" prop="line-chart:power"/>
            </b-col>
            
        </b-row>
        <b-row>
            <b-col>
                <SuitchPropsWidget :device="current_device"/>
                <br>
                <SuitchDetailsWidget :device="current_device" />

            </b-col>
            <b-col>
                <SuitchStatusWidget :device="current_device"/>
                <br />
                <br />
        <SuitchLogWidget :device="current_device"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6"> </b-col>
            <b-col cols="4">
                <!-- more information here -->
            </b-col>
        </b-row>
    </b-container>

    <!--end::Example-->
</template>

<script>
import {
    FETCH_SINGLE_DEVICE,
    // GET_FINDMY_SOIL_SENSOR,
} from "@/core/services/store/devices.module";
import SuitchStatusWidget from "@/view/content/widgets/suitch/suitch-status-widget.vue";
import SuitchPropsWidget from "@/view/content/widgets/suitch/suitch-props-widget.vue";
import SuitchDetailsWidget from "@/view/content/widgets/suitch/suitch-details-widget.vue";
import SuitchChartWidget from "@/view/content/widgets/suitch/suitch-chart-widget.vue";
import SuitchFavourite from "@/view/content/widgets/suitch/mark-favourite-widget.vue";
import SuitchLogWidget from "@/view/content/widgets/suitch/suitch-log-widget.vue";
export default {
    data() {
        return {
            limitBatteryDate:"",
            global_wizard: {},
            current_device: null,
            markers: [],
            labelOfData: 'Power in Watts'
        };
    },

    computed: {
    },

    components: {
        SuitchLogWidget,
        SuitchFavourite,
        SuitchPropsWidget,
        SuitchStatusWidget,
        SuitchDetailsWidget,
        SuitchChartWidget,
    },

    methods: {


    },
    mounted() {
        // console.log("route:",this.$route.params);
        const device_token = this.$route.params.token;

        this.$store
            .dispatch(FETCH_SINGLE_DEVICE, { device_token })
            // go to which page after successfully login
            .then((data) => {
                // download devices list
                this.current_device = data;
                // if(this.current_device.version == 'templessv1'){
                //     this.labelOfData = 'Temperature in °C';
                // } else if(this.current_device.version == 'soilblessv1'){
                //     this.labelOfData = 'Moisture';
                // }
            });
        // this.$store
        //     .dispatch(GET_FINDMY_SOIL_SENSOR, { device_token: device_token })
        //     // go to which page after successfully login
        //     .then((data) => {
        //         data;
        //         // data is an array of objects with the next shape {value:base64, created_at: date}
        //         // decode the base64 of value field of each object and store in a local object
        //         // const imarkers = data.map((item) => {
        //         //     return {
        //         //         value: item.value,
        //         //         created_at: item.created_at,
        //         //         showTooltip: false,
        //         //     };
        //         // });
        //         // if(this.markers.length == 0){
        //         //     this.limitBatteryDate = imarkers[0].created_at;
        //         // }
        //         // this.markers = imarkers;
        //     });
    },
};
</script>
